// extracted by mini-css-extract-plugin
export default {"container":"legend_container__3Fm3H","pl6":"legend_pl6__vqAjb"};